import React, { forwardRef } from "react";
// fullname ahora se pasa como prop, no desde useAuth
const TicketVenta = forwardRef(({
    cart,
    total,
    discount,
    totalWithDiscount,
    paymentMethod,
    selectedWholesalePrice,
    tipo,
    cliente = null, // Cliente seleccionado
    fecha = new Date(),
    negocio = "Zafpan",
    fullname = "",
}, ref) => {

    // Función para obtener iniciales
    const getInitials = (name) => {
        if (!name) return "";
        return name
            .split(" ")
            .map((n) => n[0]?.toUpperCase())
            .join("");
    };
    const getCombinacionId = (product) => {
        if (product.combinaciones && product.combinaciones.length > 0) {
            return product.combinaciones[0].id; // Solo una combinación por producto
        }
        return null;
    };
    const getPrice = (product) => {
        // Si el producto pertenece a una combinación, sumar cantidades de todos los productos de esa combinación en el carrito
        const combinacionId = getCombinacionId(product);
        if (combinacionId) {
            // Buscar todos los productos del carrito que pertenezcan a la misma combinación
            const productosEnCombinacion = cart.filter(
                (p) => getCombinacionId(p) === combinacionId
            );
            // Sumar cantidades
            const sumaCantidad = productosEnCombinacion.reduce(
                (acc, p) => acc + (p.quantity || 0),
                0
            );
            // Tomar el bulto del producto base de la combinación (puedes ajustar si quieres tomar el mayor o menor)
            const cantidadBultos = product.cantidad_bultos || 0;
            if (cantidadBultos > 0 && sumaCantidad >= cantidadBultos) {
                // Aplica precio mayorista A
                const mayoristaA = product?.precios?.[0]?.precio_mayorista_a;
                if (mayoristaA !== undefined && mayoristaA !== null && !isNaN(mayoristaA) && Number(mayoristaA) > 0) {
                    return mayoristaA;
                }
            }
            // Si no, sigue con la lógica normal
        }

        // Si la venta es mayorista, usa el precio mayorista seleccionado si existe, si no el precio base
        if (tipo === "mayorista") {
            const mayorista = product?.precios?.[0]?.[selectedWholesalePrice];
            const base = product?.precios?.[0]?.precio;

            // Si el precio mayorista es válido y mayor a 0, úsalo
            if (mayorista !== undefined && mayorista !== null && !isNaN(mayorista) && Number(mayorista) > 0) {
                return mayorista;
            }
            // Si el precio base es válido y mayor a 0, úsalo
            if (base !== undefined && base !== null && !isNaN(base) && Number(base) > 0) {
                return base;
            }
            // Si ninguno es válido, muestra N/A
            return "N/A";
        }

        // Lógica exclusiva para minorista (bultos/pallets)
        const quantity = product.quantity || 0;
        const unidadesPorBulto = product.cantidad_bultos || 0; // Si es 0, no hay bultos
        const unidadesPorPalet = product.cantidad_pallets || 0; // Si es 0, no hay pallets

        // Si no hay bultos ni pallets, usa el precio general
        if (unidadesPorBulto === 0 && unidadesPorPalet === 0) {
            const base = product?.precios?.[0]?.precio;
            return (base !== undefined && base !== null && !isNaN(base) && Number(base) > 0) ? base : "N/A";
        }

        const cantidadUnidadesBulto = unidadesPorBulto; // Un bulto en unidades
        const cantidadUnidadesMayoristaB = cantidadUnidadesBulto * 10; // 10 bultos en unidades
        const cantidadUnidadesPalet = unidadesPorPalet > 0 ? unidadesPorBulto * unidadesPorPalet : null; // Solo si hay pallets

        // Si hay cantidad_pallets y la cantidad en unidades es igual o mayor a un palet, usar precio mayorista C
        if (cantidadUnidadesPalet !== null && quantity >= cantidadUnidadesPalet) {
            const mayoristaC = product?.precios?.[0]?.precio_mayorista_c;
            const base = product?.precios?.[0]?.precio;
            return (mayoristaC !== undefined && mayoristaC !== null && !isNaN(mayoristaC) && Number(mayoristaC) > 0)
                ? mayoristaC
                : (base !== undefined && base !== null && !isNaN(base) && Number(base) > 0 ? base : "N/A");
        }

        // Si la cantidad en unidades es igual o mayor a 10 bultos pero menor que un palet (si existe), usar precio mayorista B
        if (quantity >= cantidadUnidadesMayoristaB && (cantidadUnidadesPalet === null || quantity < cantidadUnidadesPalet)) {
            const mayoristaB = product?.precios?.[0]?.precio_mayorista_b;
            const base = product?.precios?.[0]?.precio;
            return (mayoristaB !== undefined && mayoristaB !== null && !isNaN(mayoristaB) && Number(mayoristaB) > 0)
                ? mayoristaB
                : (base !== undefined && base !== null && !isNaN(base) && Number(base) > 0 ? base : "N/A");
        }

        // Si la cantidad en unidades es igual o mayor a un bulto pero menor a 10 bultos, usar precio mayorista A
        if (quantity >= cantidadUnidadesBulto && quantity < cantidadUnidadesMayoristaB) {
            const mayoristaA = product?.precios?.[0]?.precio_mayorista_a;
            const base = product?.precios?.[0]?.precio;
            return (mayoristaA !== undefined && mayoristaA !== null && !isNaN(mayoristaA) && Number(mayoristaA) > 0)
                ? mayoristaA
                : (base !== undefined && base !== null && !isNaN(base) && Number(base) > 0 ? base : "N/A");
        }

        // Si la cantidad es menor a un bulto o no hay configuración de bultos, usar el precio general
        const base = product?.precios?.[0]?.precio;

        return (base !== undefined && base !== null && !isNaN(base) && Number(base) > 0) ? base : "N/A";
    };
    return (
        <div
            ref={ref}

            style={{
                width: "8cm",
                fontFamily: "monospace",
                background: "#fff",
                color: "#222",
                padding: "10px",
                fontSize: "13px",
            }}
        >
            <div style={{ textAlign: "center", marginBottom: 10 }}>
                <strong style={{ fontSize: 18 }}>{negocio}</strong>
                <div>{fecha.toLocaleString()}</div>
                <hr />
            </div>

            {/* Información del cliente */}
            <div style={{ marginBottom: 10 }}>
                <strong>Cliente: </strong>
                {cliente ? cliente.nombre : "Consumidor Final"}
            </div>
            <hr />
            <div>
                {cart.map((item) => (
                    <div key={item.id} style={{ marginBottom: 4 }}>
                        <div>
                            <strong>{item.nombre_producto}</strong>
                        </div>
                        <div>
                            {item.quantity} x ${getPrice(item)} = ${(getPrice(item) * item.quantity).toFixed(2)}                        </div>
                    </div>
                ))}
            </div>
            <hr />
            <div>
                <div>
                    <span>Subtotal:</span>
                    <span style={{ float: "right" }}>${total}</span>
                </div>
                {discount > 0 && (
                    <div>
                        <span>Descuento:</span>
                        <span style={{ float: "right" }}>-${discount}</span>
                    </div>
                )}
                <div style={{ fontWeight: "bold", fontSize: 16 }}>
                    <span>Total:</span>
                    <span style={{ float: "right" }}>${totalWithDiscount}</span>
                </div>
                <div>
                    <span>Pago:</span>
                    <span style={{ float: "right" }}>{paymentMethod}</span>
                </div>
            </div>
            <hr />
            <div style={{ textAlign: "center", marginTop: 10 }}>
                ¡Gracias por su compra!<br />
                Vendedor: <b>{getInitials(fullname)}</b>
            </div>
        </div>
    );
});

export default TicketVenta;
